import { useTranslation } from 'react-i18next';
import { IItem } from '..';
import Button from '../../../Common/Button';
import Input from '../../../Common/Input';
import PolygonCanvas from '../../../Common/PolygonCanvas';
import MultiPolygonCanvas from '../../../Common/PolygonCanvas/MultipolygonCanvas';
import { VisualRepresentationWrapper, Wrapper } from './style';

interface MultiPolygonIItem {
  data: GeoJSON.Feature<GeoJSON.MultiPolygon>;
  name: string;
}
interface Props {
  onChange: (name: string) => void;
  onClick: () => void;
  value: IItem | MultiPolygonIItem;
  disabled: boolean;
  errorText?: string;
}

const EditRegion = ({
  onChange,
  onClick,
  value,
  disabled,
  errorText,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <VisualRepresentationWrapper>
        {value.data.geometry.type === 'Polygon' ? (
          <PolygonCanvas
            width={130}
            height={130}
            polygon={value.data as GeoJSON.Feature<GeoJSON.Polygon>}
            fillColor="rgba(20, 162, 241, 0.56)"
            strokeColor="rgba(20, 162, 241, 1)"
            dataTestId="upload-modal-edit-region-canvas-polygon"
            lineWidth={2}
          />
        ) : (
          <MultiPolygonCanvas
            width={130}
            height={130}
            polygon={value.data as GeoJSON.Feature<GeoJSON.MultiPolygon>}
            fillColor="rgba(20, 162, 241, 0.56)"
            strokeColor="rgba(20, 162, 241, 1)"
            dataTestId="upload-modal-edit-region-canvas-multipolygon"
            lineWidth={2}
          />
        )}
      </VisualRepresentationWrapper>
      <Input
        onChange={onChange}
        value={value.name}
        label="New region name"
        maxLength={25}
        fullWidth
        placeholder="Type your region name here"
        dataTestId="upload-modal-edit-region-name-input"
        error={errorText}
      />
      <Button
        variant="purple"
        onClick={onClick}
        additionalSx={{ marginTop: 'auto' }}
        disabled={disabled}
        dataTestId="upload-modal-edit-region-save-button"
      >
        {t('Save region name')}
      </Button>
    </Wrapper>
  );
};

export default EditRegion;
